export default __webpack_public_path__ + "static/media/person_2@3x.f658a30c.png";